import { render, staticRenderFns } from "./supportlist.vue?vue&type=template&id=cf6bfaa0&scoped=true"
import script from "./supportlist.vue?vue&type=script&lang=js"
export * from "./supportlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6bfaa0",
  null
  
)

export default component.exports